// frontend/src/services/api.js
import API from "./axiosInstance";
// ---------------------------------------------------------
// ROTATION ENGINE
// ---------------------------------------------------------
export const getLatestRotation = () => API.get("/rotation/latest");
export const getRotationHistory = () => API.get("/rotation/history");
export const getRotationDates = () => API.get("/rotation/dates");
export const getRotationByDate = (date) => API.get(`/rotation/by-date/${date}`);
export const previewRotation = () => API.post("/rotation/preview");
// ---------------------------------------------------------
// PORTFOLIO (SIPP / ISA / TRADING)
// ---------------------------------------------------------
export const getSippFunds = (runDate) =>
  runDate ? API.get("/portfolio/sipp", { params: { run_date: runDate } }) : API.get("/portfolio/sipp");
export const addSippFunds = (ids) => API.post("/portfolio/sipp/add", { ids });
export const removeSippFunds = (ids) => API.post("/portfolio/sipp/remove", { ids });
export const getIsaFunds = (runDate) =>
  runDate ? API.get("/portfolio/isa", { params: { run_date: runDate } }) : API.get("/portfolio/isa");
export const addIsaFunds = (ids) => API.post("/portfolio/isa/add", { ids });
export const removeIsaFunds = (ids) => API.post("/portfolio/isa/remove", { ids });
export const getTradingFunds = (runDate) =>
  runDate ? API.get("/portfolio/trading", { params: { run_date: runDate } }) : API.get("/portfolio/trading");
export const addTradingFunds = (ids) => API.post("/portfolio/trading/add", { ids });
export const removeTradingFunds = (ids) => API.post("/portfolio/trading/remove", { ids });
// ---------------------------------------------------------
// CHARTS
// ---------------------------------------------------------
export const getSippChart = () => API.get("/portfolio/sipp/chart");
export const getIsaChart = () => API.get("/portfolio/isa/chart");
export const getTradingChart = () => API.get("/portfolio/trading/chart");
export const getRotationChart = () => API.get("/portfolio/rotation/chart");
export const compareFundsChart = (ids) => API.post("/charts/compare", { ids });
// ---------------------------------------------------------
// FUND HISTORY
// ---------------------------------------------------------
export const getFundHistory = (fundId) =>
  API.get(`/rotation/fund-history/${fundId}`);
// ---------------------------------------------------------
// AUTHENTICATION
// ---------------------------------------------------------
export const registerUser = (data) => API.post("/auth/register", data);
export const loginUser = (data) => API.post("/auth/login", data);
export const verifyEmail = (token) => API.get(`/auth/verify-email?token=${token}`);
export const requestPasswordReset = (email) => API.post("/auth/password-reset", { email });
export const submitNewPassword = (payload) => API.post("/auth/password-reset/confirm", payload);
export const submitTwoFactor = (payload) => API.post("/auth/two-factor", payload);
export const getCurrentUser = () => API.get("/auth/me");
// ---------------------------------------------------------
// ADMIN
// ---------------------------------------------------------
export const addFundToRotation = (ticker, name) =>
  API.post("/admin/funds", { ticker, name, active: true });
export const removeFundFromRotation = (fundId) =>
  API.delete(`/admin/funds/${fundId}`);
export const triggerRotationRun = () =>
  API.post("/admin/run-rotation");
export const triggerBackfill = (startDate) =>
  API.post("/admin/backfill", null, {
    params: startDate ? { start_date: startDate } : {},
  });
